export default __webpack_public_path__ + "static/media/Sanskriti-Museum-logo.393cd0ee.jpg";